<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { loc, mloc } from "module/utils";
  import { FilterType, type SearchFilter } from "module/store/Filters";

  let { filter }: { filter: SearchFilter } = $props();
  const dispatch = createEventDispatcher();

  function changeTag(evt: Event) {
    const target = evt.target as HTMLInputElement | undefined;
    if (target?.value && target?.checkValidity()) {
      dispatch("tagChange", target.value);
    }
  }

  function changeSubTitle(evt: Event) {
    const target = evt.target as HTMLInputElement | undefined;
    if (target?.value) {
      dispatch("subTitleChange", target.value);
    }
  }

  function changeRole(evt: Event) {
    const target = evt.target as HTMLInputElement | undefined;
    if (target?.value) {
      dispatch("roleChange", parseInt(target.value));
    }
  }
</script>

<header>
  <div class="basics">
    <label class="option-label" for="filter-keyword"
      >{mloc("FilterListHeaderTag")}</label
    >
    <div class="filter-keyword">
      <span class="filter-prefix">@</span>
      <input
        type="text"
        name="filter-keyword"
        id="filter-keyword"
        value={filter.tag}
        placeholder={mloc("FilterListFilterTagPlaceholder")}
        pattern="[A-Za-z0-9\._\-]+"
        minlength="1"
        maxlength="36"
        readonly={filter.type === FilterType.Default}
        on:change={changeTag}
      />
    </div>
    <label class="option-label" for="filter-title">
      {mloc("FilterListHeaderTitle")}
    </label>
    <input
      class="filter-title"
      type="text"
      name="filter-title"
      id="filter-title"
      value={filter.subTitle}
      placeholder={mloc("FilterListFilterTitlePlaceholder")}
      minlength="1"
      maxlength="96"
      readonly={filter.type === FilterType.Default}
      on:change={changeSubTitle}
    />
  </div>
  <div class="settings">
    {#if filter.type === FilterType.World}
      <label for="qi-f-role" title="qi-f-role"
        >{mloc("FilterListHeaderUserRole")}</label
      >
      <select name="qi-f-role" id="qi-f-role" on:change={changeRole}>
        <option
          value={CONST.USER_ROLES.PLAYER}
          selected={filter.role === CONST.USER_ROLES.PLAYER}
        >
          {loc("USER.RolePlayer")}
        </option>
        <option
          value={CONST.USER_ROLES.TRUSTED}
          selected={filter.role === CONST.USER_ROLES.TRUSTED}
          >{loc("USER.RoleTrusted")}
        </option>
        <option
          value={CONST.USER_ROLES.ASSISTANT}
          selected={filter.role === CONST.USER_ROLES.ASSISTANT}
          >{loc("USER.RoleAssistant")}
        </option>
        <option
          value={CONST.USER_ROLES.GAMEMASTER}
          selected={filter.role === CONST.USER_ROLES.GAMEMASTER}
          >{loc("USER.RoleGamemaster")}
        </option>
      </select>
    {/if}
  </div>
  <div class="extra">
    <span on:click={() => dispatch("toggle", filter.id)}>
      {filter.disabled
        ? mloc("FilterListOptionEnable")
        : mloc("FilterListOptionDisable")}
      <i class="fas {filter.disabled ? 'fa-eye-slash' : 'fa-eye'}"></i>
    </span>
    <span on:click={() => dispatch("clone", filter.id)}>
      {loc("Duplicate")}
      <i class="fas fa-clone"></i>
    </span>
    {#if filter.type !== FilterType.Default}
      <span on:click={() => dispatch("delete", filter.id)}>
        {loc("Delete")}
        <i class="fas fa-trash"></i>
      </span>
    {/if}
  </div>
</header>

<style>
  header {
    display: flex;
    flex-direction: row;
    gap: 6px;
  }
  .basics {
    flex: 2;
  }
  .settings {
    flex: 1;
  }

  .filter-keyword {
    display: flex;
    position: relative;
  }
  .filter-prefix {
    position: absolute;
    top: 50%;
    left: 3px;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .filter-keyword,
  .filter-title {
    display: flex;
    line-height: 24px;
    margin: 0;
  }

  .filter-keyword input {
    padding-left: 15px;
  }

  .filter-keyword input:invalid {
    border: 1px solid red;
  }
  .filter-keyword input::placeholder {
    color: #f0f0e0;
    opacity: 0.5;
  }
  label {
    display: block;
    flex-grow: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .extra {
    display: flex;
    flex-direction: column;
    line-height: 1.6em;
  }
  .extra span {
    text-align: right;
    cursor: pointer;
  }
</style>
